import { getFinancialAidAcademicYearStartYear } from './academic-year';

const readText = (value: unknown): string => String(value ?? '').trim();

export type FinancialAidApplicationHistoryComparable = {
  academicYear?: unknown;
  submittedAt?: unknown;
  lastActivityAt?: unknown;
  updatedAt?: unknown;
  createdAt?: unknown;
};

export const toFinancialAidHistoryEpochMilliseconds = (value: unknown): number => {
  if (typeof value === 'number' && Number.isFinite(value)) {
    return value > 1_000_000_000_000 ? value : value * 1000;
  }
  const text = readText(value);
  if (!text) return 0;
  const numeric = Number(text);
  if (Number.isFinite(numeric)) {
    return numeric > 1_000_000_000_000 ? numeric : numeric * 1000;
  }
  const parsed = Date.parse(text);
  return Number.isFinite(parsed) ? parsed : 0;
};

export const getFinancialAidApplicationHistoryTimestamp = (
  application: FinancialAidApplicationHistoryComparable,
): number => toFinancialAidHistoryEpochMilliseconds(
  application.submittedAt
  ?? application.lastActivityAt
  ?? application.updatedAt
  ?? application.createdAt,
);

export const compareFinancialAidApplicationHistory = (
  left: FinancialAidApplicationHistoryComparable,
  right: FinancialAidApplicationHistoryComparable,
): number => {
  const leftYearStart = getFinancialAidAcademicYearStartYear(left.academicYear);
  const rightYearStart = getFinancialAidAcademicYearStartYear(right.academicYear);

  if (leftYearStart !== null && rightYearStart !== null) {
    if (leftYearStart !== rightYearStart) return rightYearStart - leftYearStart;
    return getFinancialAidApplicationHistoryTimestamp(right) - getFinancialAidApplicationHistoryTimestamp(left);
  }

  if (leftYearStart === null && rightYearStart !== null) return 1;
  if (leftYearStart !== null && rightYearStart === null) return -1;

  return getFinancialAidApplicationHistoryTimestamp(right) - getFinancialAidApplicationHistoryTimestamp(left);
};
